import { EMPTY_LIST } from '../../../../constants/common'
import { getItemsFromApiResponse } from '../../../../utils/api'
import { getUserAvatar, getUserFullName } from '../../../../utils/user'
import { BirdviewScope } from '../../DashboardBirdview.constants'

function toBirdviewTeamMemberItem(member) {
  return {
    avatarProps: getUserAvatar(member),
    id: member.id,
    title: getUserFullName(member),
  }
}

// A team member's load is the same "my scope" count the dashboard runs for the
// viewer, taken for their id instead.
export function getBirdviewTeamMemberParams(member) {
  return { scope: BirdviewScope.Mine, userId: member.id }
}

export function toBirdviewTeamLoadItems(response) {
  return (getItemsFromApiResponse(response) ?? EMPTY_LIST).map(
    toBirdviewTeamMemberItem
  )
}

// The manager list is an old-API endpoint, with no pagination envelope of its
// own.
export function getBirdviewTeamLoadTotal({ items, response }) {
  return response.data.count ?? items.length
}
